const locations = [
  {
    "id": 1,
    "name": "Cox's Bazar",
    "image": "https://i.ibb.co/6Rx1PCZ/Sajek.png",
    "description": "Cox’s Bazar is a town on the southeast coast of Bangladesh. It’s known for its very long, sandy beachfront, stretching from Sea Beach in the north to Kolatoli Beach in the south. Aggameda Khyang monastery is home to bronze statues and centuries-old Buddhist manuscripts. South of town, the tropical rainforest of Himchari National Park has waterfalls and many birds. North, sea turtles breed on nearby Sonadia Island.",
    "hotels": [
      {
        id: 0,
        image: 'https://i.ibb.co/R260GQJ/Rectangle-26.png',
        title: 'Light bright airy stylish apt & safe peaceful stay',
        type: '4 guests  2 bedrooms  2 bed  2 baths ',
        type1: 'Wif Air conditioning Kitchen',
        type2: 'Cancellation fexibility available',
        star: '4.9 (20)',
        dollars: 34
      },
      {
        id: 1,
        image: 'https://i.ibb.co/2KGXjvq/Rectangle-27.png',
        title: 'Apartment in Lost Panorama',
        type: '4 guests  2 bedrooms  2 bed  2 baths ',
        type1: 'Wif Air conditioning Kitchen',
        type2: 'Cancellation fexibility available',
        star: '4.8 (10)',
        dollars: 52
      },
      {
        id: 2,
        image: 'https://i.ibb.co/R260GQJ/Rectangle-26.png',
        title: 'AR Lounge & Pool (r&r + b&b)',
        type: '4 guests  2 bedrooms  2 bed  2 baths ',
        type1: 'Wif Air conditioning Kitchen',
        type2: 'Cancellation fexibility available',
        star: '4.9 (25)',
        dollars: 44
      }
    ]
  },
  {
    "id": 2,
    "name": "Sreemangal",
    "image": "https://i.ibb.co/Qf3Y32p/Sreemongol.png",
    "description": "It is said the destination Sreemangal (or Srimangal) is destinationd after Sri Das and Mangal Das; two brothers who settled on the banks of the Hail Haor.[2] A copper plate of Raja Marundanath from the 11th century was found in Kalapur. During an excavation at Lamua, an ancient statue of Ananta Narayan was dug out. In 1454, the Nirmai Shiva Bari was built and still stands today.",
    "hotels": [
      {
        id: 0,
        image: 'https://i.ibb.co/2KGXjvq/Rectangle-27.png',
        title: 'Light bright airy stylish apt & safe peaceful stay',
        type: '4 guests  2 bedrooms  2 bed  2 baths ',
        type1: 'Wif Air conditioning Kitchen',
        type2: 'Cancellation fexibility available',
        star: '4.9 (20)',
        dollars: 34
      },
      {
        id: 1,
        image: 'https://i.ibb.co/R260GQJ/Rectangle-26.png',
        title: 'Apartment in Lost Panorama',
        type: '4 guests  2 bedrooms  2 bed  2 baths ',
        type1: 'Wif Air conditioning Kitchen',
        type2: 'Cancellation fexibility available',
        star: '4.8 (10)',
        dollars: 52
      },
      {
        id: 2,
        image: 'https://i.imgur.com/xAhXefg.png',
        title: 'AR Lounge & Pool (r&r + b&b)',
        type: '4 guests  2 bedrooms  2 bed  2 baths ',
        type1: 'Wif Air conditioning Kitchen',
        type2: 'Cancellation fexibility available',
        star: '4.9 (25)',
        dollars: 44
      }
    ]
  },
  {
    "id": 3,
    "name": "Sundarbans",
    "image": "https://i.ibb.co/52bY9LB/sundorbon.png",
    "profile": "https://i.ibb.co/PYscqbL/bfa7be922fb74a04bf45a5db4b723418.jpg",
    "description": "The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal. It spans from the Hooghly River in India's state of West Bengal to the Baleswar River in Bangladesh.",
    "hotels": [
      {
        id: 0,
        image: 'https://i.ibb.co/2KGXjvq/Rectangle-27.png',
        title: 'Light bright airy stylish apt & safe peaceful stay',
        type: '4 guests  2 bedrooms  2 bed  2 baths ',
        type1: 'Wif Air conditioning Kitchen',
        type2: 'Cancellation fexibility available',
        star: '4.9 (20)',
        dollars: 34
      },
      {
        id: 1,
        image: 'https://i.ibb.co/R260GQJ/Rectangle-26.png',
        title: 'Apartment in Lost Panorama',
        type: '4 guests  2 bedrooms  2 bed  2 baths ',
        type1: 'Wif Air conditioning Kitchen',
        type2: 'Cancellation fexibility available',
        star: '4.8 (10)',
        dollars: 52
      },
      {
        id: 2,
        image: 'https://i.imgur.com/xAhXefg.png',
        title: 'AR Lounge & Pool (r&r + b&b)',
        type: '4 guests  2 bedrooms  2 bed  2 baths ',
        type1: 'Wif Air conditioning Kitchen',
        type2: 'Cancellation fexibility available',
        star: '4.9 (25)',
        dollars: 44
      }
    ]
  },
  
]

export default locations;